import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetClientListNetwork,
  getMonthsYearsAction,
} from "../../../redux/actions/GlobalAction";
import Datetime from "react-datetime";
import Select from "react-select";
import { getAllProviderListNetworkAction } from "../../../redux/actions/TestPackageNetworkAction";
import { placeholderSelectColor } from "../NetworkIntelligence/UsageCoverage/helper";
import { InputOptionSelect } from "../../../common/InputOptionSelect";
import { funnelCard, initSendToQc, initialFilterState } from "./helper";
import {
  AddPayoutApprovalAction,
  GeneratePayoutAction,
  GetAppointmentPayoutDetailsNetworkAction,
  GetPayoutStatus,
  getPayoutCountsNetworkAction,
  getPayoutDetailsNetworkAction,
  getProviderPayoutDetailsNetworkAction,
  GetTotalCloseAppointmentDetailsNetwork,
} from "../../../redux/actions/PayoutAction";
import Modal from "react-modal";
import { TotalPayout } from "./TotalPayout";
import { SearchIcon } from "../../../Utils/SvgIcons";
import "../../../assets/css/payout.css";
import { TotalProvider } from "./TotalProvider";
import { TotalAppointments } from "./TotalAppointments";
import { UnsuccessfulAppointment } from "./UnsuccessfulAppointment";
import { PayoutSentToQc } from "./PayoutSentToQc";
import { getSnackbarSuccess, isLoadingAction } from "../../../Utils/helper";
import { API_URL_WITHOUT_USER } from "../../../Utils/API";
import {
  getMenus,
  getNetworkMenuId,
  getToken,
  validateProviderPayout,
} from "../../../Utils/types";
import { AdditionalApptHeader } from "./AdditionalApptHeader";
import { isValidDate } from "../../ServicePortal/ProfileDetail/helper";
import { clearCurrentPage } from "../ProviderProfileDetails/helper";
import { PayoutExportToExcel } from "./PayoutExportToExcel";
import { BulkRateUpload } from "./BulkRateUpload";
import { SendToQcBulkUpload } from "./SendToQcBulkUpload";
import { TotalClosedApprointments } from "./TotalClosedApprointments";
import AdditionalComponentHeader from "../../helperComponent/AdditionalComponentHeader";
import { PayoutAdjustment } from "./PayoutAdjustment";

export const PayOut = ({ setadpTab }) => {
  const [providerValues, setProviderValues] = useState(null);
  const [switchTab, setSwitchTab] = useState("totalPayouts");
  const [client, setClient] = useState(null);
  const [searchFilter, setSearchFilter] = useState(initialFilterState);
  const [sendToQcPayload, setSendToQcPayload] = useState(initSendToQc);
  const [header, setHeader] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllFlag, setSelectAllFlag] = useState(false);
  const [isOpenSetting, setIsOpenSetting] = useState(false);
  const [isExportToExcel, setIsExporToExcel] = useState(false);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [bulkSendToQC, setBulkSendToQC] = useState(false);
  const [inputClient, setInputClient] = useState("");
  const [providerDetail, setProviderDetail] = useState([]);
  const [month, setMonth] = useState(null);
  const [showData, setShowData] = useState(false);
  const [bulkRate, setBulkRate] = useState(false);
  const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const dispatch = useDispatch();

  const [openModel, setOpenModel] = useState({
    adjustAmount: false,
  });

  let validateBtn = validateProviderPayout()[0]?.subMenus[0];

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  useEffect(() => {
    dispatch(GetPayoutStatus(false, true));
    dispatch(
      GetClientListNetwork({ clientId: 0, clientName: "", BusinessType: "CBU" })
    );
    dispatch(getMonthsYearsAction());
    dispatch(getAllProviderListNetworkAction());
    dispatch(getPayoutCountsNetworkAction(searchFilter));
  }, []);

  const sendToQcHandler = async (ref) => {
    console.log("sendToQC", sendToQcPayload);
    setSendToQcPayload();
    let res;
    if (switchTab === "totalPayouts") {
      res = await dispatch(
        AddPayoutApprovalAction({
          ...sendToQcPayload,
          year: providerDetail[0]?.year,
          month: providerDetail[0]?.month,
          providerIds: [],
          qcType: "MONTHWISE",
          BusinessType: searchFilter?.BusinessType,
          RequestStatus: "PENDINGATPROVIDER",
        })
      );
      if (res) {
        setTimeout(() => {
          dispatch(getPayoutDetailsNetworkAction(searchFilter));
        }, 1000);
      }
    } else if (switchTab === "totalProviders") {
      let prvId = providerDetail.map((ele) => {
        return { providerId: ele?.providerId };
      });
      res = await dispatch(
        AddPayoutApprovalAction({
          ...sendToQcPayload,
          year: providerDetail[0]?.year,
          month: providerDetail[0]?.month,
          qcType: "PROVIDERWISE",
          providerIds: prvId,
          BusinessType: searchFilter?.BusinessType,
          RequestStatus: "PENDINGATPROVIDER",
        })
      );
      setTimeout(() => {
        dispatch(
          getProviderPayoutDetailsNetworkAction({
            ...searchFilter,
            IsPayoutStatus: true,
          })
        );
      }, 1000);
    } else if (switchTab === "totalApppointments") {
      let apID = providerDetail.map((ele) => {
        return { appointmentId: ele?.appointmentId };
      });
      let prvId = providerDetail.map((ele) => {
        return { providerId: ele?.providerId };
      });
      res = await dispatch(
        AddPayoutApprovalAction({
          ...sendToQcPayload,
          year: providerDetail[0]?.year,
          month: providerDetail[0]?.month,
          qcType: "APPOINTMENTWISE",
          appointmentIds: apID,
          providerIds: prvId,
          BusinessType: searchFilter?.BusinessType,
          RequestStatus: "PENDINGATPROVIDER",
        })
      );
      setTimeout(() => {
        dispatch(
          GetAppointmentPayoutDetailsNetworkAction({
            ...searchFilter,
            IsPayoutStatus: true,
          })
        );
      }, 1000);
    }
    if (res) {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("success", res?.data?.message, dispatch);
      ref.current.click();
      setSelectAllFlag(false);
      setSelectAll(false);
      setProviderDetail([]);
      setSendToQcPayload(initSendToQc);
    }
  };

  const handleDataCount = (e) => {
    setSearchFilter({
      ...searchFilter,
      page: 1,
      rows: e.target.value,
    });

    if (switchTab === "totalPayouts") {
      dispatch(
        getPayoutDetailsNetworkAction({
          ...searchFilter,
          page: 1,
          rows: e.target.value,
        })
      );
    } else if (switchTab === "totalProviders") {
      dispatch(
        getProviderPayoutDetailsNetworkAction({
          ...searchFilter,
          page: 1,
          rows: e.target.value,
        })
      );
    } else if (switchTab === "totalApppointments") {
      dispatch(
        GetAppointmentPayoutDetailsNetworkAction({
          ...searchFilter,
          IsPayoutStatus: true,
          page: 1,
          rows: e.target.value,
        })
      );
    } else if (switchTab === "unSuccessfullAppointments") {
      dispatch(
        GetAppointmentPayoutDetailsNetworkAction({
          ...searchFilter,
          IsPayoutStatus: false,
          page: 1,
          rows: e.target.value,
        })
      );
    } else if (switchTab === "totalCloseAppointments") {
      dispatch(
        GetTotalCloseAppointmentDetailsNetwork({
          ...searchFilter,
          IsPayoutStatus: false,
          page: 1,
          rows: e.target.value,
        })
      );
    }
    setIsLoadingExcel(false);
    setSelectAllFlag(false);
    setSelectAll(false);
    setProviderDetail([]);
  };

  const handleSearch = () => {
    clearCurrentPage(dispatch);
    dispatch(getPayoutCountsNetworkAction({ ...searchFilter, page: 1 }));
    if (switchTab === "totalPayouts") {
      dispatch(getPayoutDetailsNetworkAction({ ...searchFilter, page: 1 }));
    } else if (switchTab === "totalProviders") {
      dispatch(
        getProviderPayoutDetailsNetworkAction({ ...searchFilter, page: 1 })
      );
    } else if (switchTab === "totalApppointments") {
      dispatch(
        GetAppointmentPayoutDetailsNetworkAction({
          ...searchFilter,
          IsPayoutStatus: true,
          page: 1,
        })
      );
    } else if (switchTab === "unSuccessfullAppointments") {
      dispatch(
        GetAppointmentPayoutDetailsNetworkAction({
          ...searchFilter,
          IsPayoutStatus: false,
          page: 1,
        })
      );
    } else if (switchTab === "totalCloseAppointments") {
      dispatch(
        GetTotalCloseAppointmentDetailsNetwork({
          ...searchFilter,
          IsPayoutStatus: false,
          page: 1,
        })
      );
    }
    setSelectAll(false);
    setProviderDetail([]);
    setSelectAllFlag(false);
  };

  const handleSorting = async (type) => {
    changeHandler("SortDirection", type);
    if (switchTab === "totalPayouts") {
      dispatch(
        getPayoutDetailsNetworkAction({ ...searchFilter, SortDirection: type })
      );
    } else if (switchTab === "totalProviders") {
      dispatch(
        getProviderPayoutDetailsNetworkAction({
          ...searchFilter,
          SortDirection: type,
        })
      );
    } else if (switchTab === "totalApppointments") {
      dispatch(
        GetAppointmentPayoutDetailsNetworkAction({
          ...searchFilter,
          IsPayoutStatus: true,
          SortDirection: type,
        })
      );
    } else if (switchTab === "unSuccessfullAppointments") {
      dispatch(
        GetAppointmentPayoutDetailsNetworkAction({
          ...searchFilter,
          IsPayoutStatus: false,
          SortDirection: type,
        })
      );
    } else if (switchTab === "totalCloseAppointments") {
      dispatch(
        GetTotalCloseAppointmentDetailsNetwork({
          ...searchFilter,
          IsPayoutStatus: false,
          SortDirection: type,
        })
      );
    }
  };

  const downloadFile = (ele) => {
    isLoadingAction(true, dispatch);
    setIsLoadingExcel(true);
    let apid;
    let prvid = providerDetail.map((ele) => ele?.providerId);
    let mthId = providerDetail.map((ele) => {
      return ele?.month;
    });
    let sortMonth = mthId.sort();
    let mth = [];
    for (let i = 0; i < sortMonth.length; i++) {
      if (sortMonth[i] !== sortMonth[i + 1]) {
        mth.push({ monthId: sortMonth[i] });
      }
    }
    if (
      switchTab === "totalApppointments" ||
      switchTab === "unSuccessfullAppointments" ||
      switchTab === "totalCloseAppointments"
    ) {
      apid = providerDetail.map((ele) => {
        return { AppointmentId: ele?.appointmentId };
      });
    }
    let url = "";
    if (switchTab === "totalCloseAppointments")
      url = `${API_URL_WITHOUT_USER}/NetworkPayout/ExportToExcelTotalClosedApptDetailsNetwork`;
    else
      url = `${API_URL_WITHOUT_USER}/NetworkPayout/ExportToExcelPayoutDetailsNetwork`;
    let data;
    {
      if (switchTab === "totalPayouts") {
        data = {
          ...searchFilter,
          isPayoutStatus: true,
          month: ele?.month,
        };
      } else if (switchTab === "totalProviders" && selectAll === false) {
        data = {
          ...searchFilter,
          isPayoutStatus: true,
          payoutMonths: mth,
          month: ele?.month,
          providerIds:
            prvid.length > 1 ? prvid.toString() : ele?.providerId?.toString(),
        };
      } else if (switchTab === "totalProviders" && selectAll === true) {
        data = {
          ...searchFilter,
          isPayoutStatus: true,
          // payoutMonths: mth,
          // month: searchFilter?.month,
          // providerIds:
          //   "",
        };
      } else if (switchTab === "totalApppointments" && selectAll === false) {
        data = {
          ...searchFilter,
          isPayoutStatus: true,
          providerIds: prvid.toString(),
          appointmentIds: apid,
          payoutMonths: mth,
          month: ele?.month,
        };
      } else if (switchTab === "totalApppointments" && selectAll === true) {
        data = {
          ...searchFilter,
          isPayoutStatus: true,
          // providerIds: "",
          // appointmentIds: [],
          // payoutMonths: [],
          // month: ele?.month,
        };
      } else if (
        switchTab === "unSuccessfullAppointments" &&
        selectAll === false
      ) {
        data = {
          ...searchFilter,
          isPayoutStatus: false,
          providerIds: prvid.toString(),
          appointmentIds: apid,
          payoutMonths: mth,
          month: ele?.month,
        };
      } else if (
        switchTab === "unSuccessfullAppointments" &&
        selectAll === true
      ) {
        data = {
          ...searchFilter,
          isPayoutStatus: false,
          // providerIds: "",
          // appointmentIds: [],
          // payoutMonths: [],
          // month: ele?.month,
        };
      } else if (
        switchTab === "totalCloseAppointments" &&
        selectAll === false
      ) {
        data = {
          ...searchFilter,
          isPayoutStatus: false,
          providerIds: prvid.toString(),
          appointmentIds: apid,
          payoutMonths: mth,
          month: ele?.month,
        };
      } else if (switchTab === "totalCloseAppointments" && selectAll === true) {
        data = {
          ...searchFilter,
          isPayoutStatus: false,
        };
      }
    }

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        isLoadingAction(false, dispatch);
        const filename = "ProviderPayoutDetails.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoadingExcel(false);
        setSelectAllFlag(false);
        setSelectAll(false);
        setProviderDetail([]);
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
        setIsLoadingExcel(false);
        // isLoadingAction(false, dispatch);
      });
  };

  const generatePayout = async () => {
    let prvid = providerDetail.map((ele) => ele?.providerId);
    let apID = providerDetail.map((ele) => {
      return { appointmentId: ele?.appointmentId };
    });
    let res = await dispatch(
      GeneratePayoutAction({
        ...searchFilter,
        appointmentIds: apID,
        providerIds: selectAll === false ? prvid.toString() : "",
      })
    ).then((res) => {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("success", res?.data?.message, dispatch);
      setTimeout(() => {
        dispatch(
          GetAppointmentPayoutDetailsNetworkAction({
            ...searchFilter,
            IsPayoutStatus: false,
            page: 1,
          })
        );
        dispatch(getPayoutCountsNetworkAction({ ...searchFilter, page: 1 }));
        setProviderDetail([]);
      }, 1000);
    });
  };

  const handleClear = () => {
    setClient(null);
    setProviderValues(null);
    setProviderDetail([]);
    setInputClient("");
    setSearchFilter(initialFilterState);
    setShowData(false);
    setMonth(new Date().getMonth + 1);
    dispatch(getPayoutCountsNetworkAction(initialFilterState));
    if (switchTab === "totalPayouts") {
      dispatch(getPayoutDetailsNetworkAction(initialFilterState));
    } else if (switchTab === "totalProviders") {
      dispatch(getProviderPayoutDetailsNetworkAction(initialFilterState));
    } else if (switchTab === "totalApppointments") {
      dispatch(
        GetAppointmentPayoutDetailsNetworkAction({
          ...initialFilterState,
          IsPayoutStatus: true,
        })
      );
    } else if (switchTab === "unSuccessfullAppointments") {
      dispatch(
        GetAppointmentPayoutDetailsNetworkAction({
          ...initialFilterState,
          IsPayoutStatus: false,
        })
      );
    } else if (switchTab === "totalCloseAppointments") {
      dispatch(
        GetTotalCloseAppointmentDetailsNetwork({
          ...initialFilterState,
          IsPayoutStatus: false,
        })
      );
    }
  };

  const BussineTypeHandler = (e) => {
    //  ref.current.value=""
    handleClear();
    setClient(null);
    setProviderValues(null);
    setProviderDetail([]);
    setInputClient("");
    setSearchFilter({ ...initialFilterState, BusinessType: e.target.value });

    dispatch(
      GetClientListNetwork({
        clientId: 0,
        clientName: "",
        BusinessType: e.target.value,
      })
    );
    dispatch(
      getPayoutCountsNetworkAction({
        ...initialFilterState,
        BusinessType: e.target.value,
      })
    );
    // if (switchTab === "totalPayouts") {
    //   dispatch(getPayoutDetailsNetworkAction({...initialFilterState,BusinessType: e.target.value}));
    // } else if (switchTab === "totalProviders") {
    //   dispatch(getProviderPayoutDetailsNetworkAction({...initialFilterState,BusinessType: e.target.value}));
    // } else if (switchTab === "totalApppointments") {
    //   dispatch(
    //     GetAppointmentPayoutDetailsNetworkAction({
    //       ...initialFilterState,
    //       IsPayoutStatus: true,
    //       BusinessType: e.target.value
    //     })
    //   );
    // } else if (switchTab === "unSuccessfullAppointments") {
    //   dispatch(
    //     GetAppointmentPayoutDetailsNetworkAction({
    //       ...initialFilterState,
    //       IsPayoutStatus: false,
    //       BusinessType: e.target.value
    //     })
    //   );
    // }
  };

  const [closedAppointmentsHeaders, setClosedAppointmentsHeaders] = useState([
    {
      label: "Provider Name",
      col: "providerName",
      show: true,
      default: true,
      index: 0,
    },
    { label: "Case No", col: "caseNo", show: true, default: true, index: 1 },
    {
      label: "Policy Ref No",
      col: "policyRefNo",
      show: false,
      default: false,
      index: 2,
    },
    {
      label: "Docket No",
      col: "docketNo",
      show: false,
      default: false,
      index: 3,
    },
    {
      label: "Proposer Name",
      col: "proposerName",
      show: true,
      default: true,
      index: 4,
    },
    {
      label: "Client Name",
      col: "clientName",
      show: true,
      default: true,
      index: 5,
    },
    {
      label: "Updated By",
      col: "updatedBy",
      show: false,
      default: false,
      index: 6,
    },
    {
      label: "Updated Date",
      col: "updatedDateTime",
      show: false,
      default: false,
      index: 7,
    },
  ]);

  const [
    isOpenSettingForClosedAppointments,
    setIsOpenSettingForClosedAppointments,
  ] = useState(false);
  return (
    <div className="right-section pt-1 pt-3" style={{ padding: "10px" }}>
      <div className="card staff-details-section">
        <div className="card-body">
          <h4 className="pt-2">Network Payout</h4>
          <div className="mt-3 d-flex flex-wrap gap-3">
            <div className="payoutBussinessType">
              <select
                name="BusinessType"
                style={{ height: "60px" }}
                className="white-form-select "
                value={searchFilter?.BusinessType}
                onChange={(e) => {
                  BussineTypeHandler(e);
                }}
              >
                <option value="IBU">IBU</option>
                <option value="CBU">CBU</option>
              </select>
            </div>
            <div className="payputMultiSelect">
              <Select
                placeholder="Client ID/Name"
                getOptionLabel={(option) => option.clientName}
                getOptionValue={(option) => option.clientId}
                className="basic-multi-select usagecoverage-search"
                classNamePrefix="select"
                isMulti
                styles={placeholderSelectColor}
                closeMenuOnSelect={false}
                name="colors"
                onChange={(event, i, value) => {
                  changeHandler("clients", event);
                }}
                value={
                  searchFilter?.clients === "" ? null : searchFilter?.clients
                }
                inputValue={inputClient}
                onInputChange={(value, action) => {
                  if (action.action === "input-change") setInputClient(value);
                  if (action.action === "menu-close") {
                    setInputClient("");
                  }
                }}
                options={globalReducer?.getClientList?.map((ele) => {
                  return {
                    clientId: ele?.clientId,
                    clientName: ele?.clientName,
                    BusinessType: ele?.businessType,
                  };
                })}
                hideSelectedOptions={false}
                components={{
                  Option: InputOptionSelect,
                }}
              />
            </div>
            <div className="payputMultiSelect">
              <Select
                placeholder="Provider ID/Name "
                className="basic-multi-select usagecoverage-search"
                classNamePrefix="select"
                isMulti
                styles={placeholderSelectColor}
                closeMenuOnSelect={false}
                name="colors"
                inputValue={providerValues?.input}
                onInputChange={(value, action) => {
                  if (action.action === "input-change") {
                    setProviderValues({
                      ...providerValues,
                      input: value,
                    });
                  }
                  if (action.action === "menu-close") {
                    setProviderValues({
                      ...providerValues,
                      input: "",
                    });
                  }
                }}
                onChange={(event) => {
                  changeHandler(
                    "providerIds",
                    event.map((e) => e.value).toString()
                  );
                  setProviderValues({
                    ...providerValues,
                    options: event,
                  });
                  dispatch(
                    getPayoutDetailsNetworkAction({
                      ...searchFilter,
                      page: 1,
                      providerIds: event.map((e) => e.value).toString(),
                    })
                  );
                }}
                value={
                  searchFilter?.providerIds === ""
                    ? null
                    : providerValues?.option
                }
                options={TestPackageReducer?.getProviderListNetworkDetails?.map(
                  (ele) => {
                    return {
                      value: ele?.providerId,
                      label: ele?.providerName,
                    };
                  }
                )}
                hideSelectedOptions={false}
                components={{
                  Option: InputOptionSelect,
                }}
              />
            </div>
            <div className="payoutBussinessType">
              <Datetime
                dateFormat="YYYY"
                timeFormat={false}
                className="page-content payoutYearFilter"
                isValidDate={isValidDate}
                value={searchFilter?.year}
                placeholder="Select Year"
                closeOnSelect={true}
                onChange={(e) =>
                  setSearchFilter({
                    ...searchFilter,
                    year: e?.format("YYYY"),
                  })
                }
              />
            </div>
            <div className="payoutBussinessType">
              <select
                name="BusinessType"
                className="white-form-select "
                style={{ height: "60px" }}
                value={month}
                onChange={(e) => {
                  setMonth(e.target.value);
                  setSearchFilter({
                    ...searchFilter,
                    month: e.target.value ? e.target.value : null,
                  });
                }}
              >
                <option value=""> Select Month</option>
                {globalReducer?.getMonthYear?.lstMonths?.map((ele) => {
                  return (
                    <option value={+ele?.monthId}>{ele?.monthName}</option>
                  );
                })}
              </select>
            </div>
            {(switchTab === "totalApppointments" ||
              switchTab === "totalProviders") && (
              <div className="payoutBussinessType">
                <select
                  name="Select Status"
                  className="white-form-select "
                  style={{ height: "60px" }}
                  value={searchFilter?.requestStatusId}
                  onChange={(e) => {
                    setSearchFilter({
                      ...searchFilter,
                      requestStatusId: e.target.value,
                    });
                  }}
                >
                  <option value="0"> Select Status</option>
                  {payoutReducer?.getpayoutStatus?.map((ele) => (
                    <option value={ele?.requestStatusId}>
                      {ele?.displayName}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
          <br />
          <div className=" gap-4 d-flex  flex-wrap">
            {funnelCard.map((ele) => {
              return (
                <div
                  className="payout-funnel-card"
                  onClick={() => {
                    setSwitchTab(ele?.value);
                    setSelectAll(false);
                    setSelectAllFlag(false);
                    setProviderDetail([]);
                    setSearchFilter({
                      ...searchFilter,
                      requestStatusId: "0",
                      page: 1,
                      caseNo: "",
                    });
                    dispatch(
                      getPayoutCountsNetworkAction({
                        ...searchFilter,
                        requestStatusId: "0",
                        caseNo: "",
                      })
                    );
                  }}
                >
                  <div
                    className={`${
                      switchTab === ele?.value
                        ? "payOutSwitchTab"
                        : "payOutSwitchTab1"
                    } servce_box`}
                    onClick={() => setHeader([])}
                  >
                    <div>
                      <img src={ele?.img} alt="exportsquare" />
                    </div>
                    <div>
                      <p>{ele?.header}</p>
                      <h3>
                        {payoutReducer?.getPayoutNetworkCount[
                          ele?.value
                        ]?.toLocaleString("en-IN")}
                      </h3>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="col-12 d-flex gap-3 pt-2 justify-content-between mb-2">
            <div className="mt-2 gap-5 ">
              <div className=" d-flex gap-1">
                {switchTab !== "totalPayouts" && (
                  <>
                    <select
                      className="row-selectdropdown"
                      value={searchFilter?.rows}
                      onChange={(e) => {
                        handleDataCount(e);
                      }}
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                    <p className="results">
                      Total <span>{globalReducer?.getTotalCount}</span> results
                    </p>
                  </>
                )}
              </div>
            </div>
            {(switchTab === "unSuccessfullAppointments" ||
              switchTab === "totalApppointments" ||
              switchTab === "totalCloseAppointments") && (
              <div className="mt-2">
                <input
                  placeholder="Case No/Policy Ref. No"
                  value={searchFilter?.caseNo}
                  className=" white-form-select  networkInputCaseNo"
                  onChange={(e) => changeHandler("caseNo", e.target.value)}
                />
              </div>
            )}
            <div className="d-flex gap-2 pt-2  justify-content-end flex-wrap">
              <button
                className="search"
                type="button"
                style={{ border: "none" }}
                onClick={handleSearch}
              >
                <a className="sidebar-links">
                  <SearchIcon />
                  <span className="sidebar-link-text">Search</span>
                </a>
              </button>
              <button
                className="search"
                type="button"
                style={{ border: "none" }}
                onClick={() => handleClear("CBU")}
              >
                <a className="sidebar-links">
                  <span className="sidebar-link-text">Clear All</span>
                </a>
              </button>
              {switchTab === "unSuccessfullAppointments" && (
                <button
                  className="btn search__btn"
                  type="button"
                  disabled={providerDetail?.length === 0}
                  style={{ border: "none" }}
                  onClick={() => generatePayout()}
                >
                  Generate Payout
                </button>
              )}
              {switchTab === "totalPayouts" && (
                <>
                  <button
                    className="ascDescBtn search__btn ps-2 p-1 text-align-center"
                    disabled={
                      validateBtn?.informationPermissions[2]?.canEdit ===
                        true ||
                      validateBtn?.informationPermissions[3]?.canEdit === true
                        ? false
                        : true
                    }
                    style={{ textAlign: "center" }}
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    Setting Payout &nbsp;
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="advancePayoutDropdown"
                  >
                    {validateBtn.informationPermissions[2]?.canEdit ===
                      true && (
                      <li>
                        <button
                          className="dropdown-item btn-border-bottom"
                          type="button"
                          onClick={() => setadpTab(true)}
                        >
                          Advance Payout
                        </button>
                      </li>
                    )}
                    {validateBtn.informationPermissions[3]?.canEdit ===
                      true && (
                      <li>
                        <button
                          className="dropdown-item"
                          type="button"
                          onClick={() => setIsExporToExcel(true)}
                        >
                          Export to Excel
                        </button>
                      </li>
                    )}
                  </ul>
                </>
              )}
              {switchTab === "totalApppointments" && (
                <>
                  <button
                    className="ascDescBtn search__btn ps-2 p-1 text-align-center"
                    style={{ textAlign: "center" }}
                    type="button"
                    disabled={
                      validateBtn.informationPermissions[0]?.canEdit === true ||
                      validateBtn.informationPermissions[1]?.canEdit === true
                        ? false
                        : true
                    }
                    data-bs-toggle="dropdown"
                  >
                    Bulk Action &nbsp;
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="advancePayoutDropdown"
                  >
                    {validateBtn.informationPermissions[0]?.canEdit ===
                      true && (
                      <li>
                        <button
                          className="dropdown-item btn-border-bottom"
                          type="button"
                          onClick={() => setBulkRate(true)}
                        >
                          Bulk Rate Update
                        </button>
                      </li>
                    )}
                    {validateBtn.informationPermissions[1]?.canEdit ===
                      true && (
                      <li>
                        <button
                          className="dropdown-item"
                          type="button"
                          onClick={() => {
                            setBulkSendToQC(true);
                          }}
                        >
                          Bulk Send To QC
                        </button>
                      </li>
                    )}
                  </ul>
                </>
              )}
              {(switchTab === "totalApppointments" ||
                switchTab === "totalProviders") && (
                <>
                  <button
                    className="btn search__btn"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#sendToQcModal"
                    disabled={providerDetail?.length < 2}
                  >
                    Send To QC &nbsp;
                    <i class="fa-solid fa-caret-right"></i>
                  </button>
                </>
              )}
              {(switchTab === "unSuccessfullAppointments" ||
                switchTab === "totalApppointments" ||
                switchTab === "totalProviders" ||
                switchTab === "totalCloseAppointments") && (
                <>
                  <button
                    disabled={providerDetail?.length < 2}
                    className="btn search__btn"
                    type="button"
                    onClick={() => {
                      console.log("done uat");
                      downloadFile();
                    }}
                  >
                    <i className="fa-solid fa-arrow-down"></i>&nbsp;Export To
                    Excel
                  </button>
                </>
              )}
              {switchTab === "totalProviders" && (
                <>
                  <button
                    className="search__btn ascDescBtn"
                    type="button"
                    id="ascDescPayableBtn"
                    data-bs-toggle="dropdown"
                    // aria-expanded="false"
                  >
                    <i className="fa fa-list"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="ascDescPayableBtn"
                  >
                    <li>
                      <button
                        className="dropdown-item btn-border-bottom"
                        type="button"
                        onClick={() => handleSorting("asc")}
                      >
                        Ascending Order
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={() => handleSorting("desc")}
                      >
                        Descending Order
                      </button>
                    </li>
                  </ul>
                </>
              )}

              {(switchTab === "unSuccessfullAppointments" ||
                switchTab === "totalApppointments" ||
                switchTab === "totalProviders" ||
                switchTab === "totalCloseAppointments") && (
                <>
                  <button
                    className="search__btn ascDescBtn p-2"
                    data-bs-toggle="modal"
                    id="ascDescPayableBtn"
                    onClick={() => {
                      if (switchTab === "totalCloseAppointments") {
                        setIsOpenSettingForClosedAppointments(true);
                      } else {
                        setIsOpenSetting(true);
                      }
                    }}
                    // data-bs-target="#additionalFilterApptHeader"
                    type="button"
                  >
                    &nbsp;
                    <i
                      class="fa-solid fa-gear"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </button>
                </>
              )}
            </div>
          </div>
          {providerDetail?.length > 0 && (
            <>
              <div className="select_all_div m-2">
                {switchTab === "totalProviders" && (
                  <>
                    {!selectAll && (
                      <>
                        <p>{providerDetail?.length} providers are selected</p>
                        {globalReducer?.getTotalCount > searchFilter.rows && (
                          <>
                            {selectAllFlag === true && (
                              <span
                                className="select_all_primary_cases"
                                onClick={() => setSelectAll(true)}
                              >
                                Select all {globalReducer?.getTotalCount}{" "}
                                providers
                              </span>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {selectAll && (
                      <p>
                        {globalReducer?.getTotalCount} providers are selected
                      </p>
                    )}
                  </>
                )}
                {(switchTab === "totalApppointments" ||
                  switchTab === "unSuccessfullAppointments" ||
                  switchTab === "totalCloseAppointments") && (
                  <>
                    {!selectAll && (
                      <>
                        <p>
                          {providerDetail?.length} appointments are selected
                        </p>
                        {globalReducer?.getTotalCount > searchFilter.rows && (
                          <>
                            {selectAllFlag === true && (
                              <span
                                className="select_all_primary_cases"
                                onClick={() => setSelectAll(true)}
                              >
                                Select all {globalReducer?.getTotalCount}{" "}
                                appointments
                              </span>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {selectAll && (
                      <p>
                        {globalReducer?.getTotalCount} appointments are selected
                      </p>
                    )}
                  </>
                )}
              </div>
            </>
          )}
          {switchTab === "totalPayouts" ? (
            <TotalPayout
              setSwitchTab={setSwitchTab}
              switchTab={switchTab}
              searchFilter={searchFilter}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
              setMonth={setMonth}
              setSearchFilter={setSearchFilter}
              downloadFile={downloadFile}
              isLoadingExcel={isLoadingExcel}
            />
          ) : switchTab === "totalProviders" ? (
            <TotalProvider
              searchFilter={searchFilter}
              setSwitchTab={setSwitchTab}
              switchTab={switchTab}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
              sendToQcHandler={sendToQcHandler}
              setSearchFilter={setSearchFilter}
              downloadFile={downloadFile}
              selectAllFlag={selectAllFlag}
              setSelectAllFlag={setSelectAllFlag}
              setSelectAll={setSelectAll}
              isLoadingExcel={isLoadingExcel}
              providerValues={providerValues}
              setProviderValues={setProviderValues}
              header={header}
            />
          ) : switchTab === "totalApppointments" ? (
            <TotalAppointments
              searchFilter={searchFilter}
              setSwitchTab={setSwitchTab}
              switchTab={switchTab}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
              sendToQcHandler={sendToQcHandler}
              setSearchFilter={setSearchFilter}
              downloadFile={downloadFile}
              header={header}
              setHeader={setHeader}
              selectAllFlag={selectAllFlag}
              setSelectAllFlag={setSelectAllFlag}
              setSelectAll={setSelectAll}
              showData={showData}
              setShowData={setShowData}
              setOpenModel={setOpenModel}
              openModel={openModel}
            />
          ) : switchTab === "unSuccessfullAppointments" ? (
            <UnsuccessfulAppointment
              searchFilter={searchFilter}
              setSwitchTab={setSwitchTab}
              switchTab={switchTab}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
              sendToQcHandler={sendToQcHandler}
              setSearchFilter={setSearchFilter}
              downloadFile={downloadFile}
              header={header}
              setHeader={setHeader}
              selectAllFlag={selectAllFlag}
              setSelectAllFlag={setSelectAllFlag}
              setSelectAll={setSelectAll}
              showData={showData}
              setShowData={setShowData}
            />
          ) : switchTab === "totalCloseAppointments" ? (
            <TotalClosedApprointments
              searchFilter={searchFilter}
              setSwitchTab={setSwitchTab}
              switchTab={switchTab}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
              sendToQcHandler={sendToQcHandler}
              setSearchFilter={setSearchFilter}
              downloadFile={downloadFile}
              header={closedAppointmentsHeaders}
              setHeader={setClosedAppointmentsHeaders}
              selectAllFlag={selectAllFlag}
              setSelectAllFlag={setSelectAllFlag}
              setSelectAll={setSelectAll}
              showData={showData}
              setShowData={setShowData}
            />
          ) : (
            ""
          )}
          <div
            class="modal fade"
            id="sendToQcModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          >
            <PayoutSentToQc
              sendToQcHandler={sendToQcHandler}
              sendToQcPayload={sendToQcPayload}
              setSendToQcPayload={setSendToQcPayload}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
            />
          </div>
          <Modal
            isOpen={isOpenSetting}
            style={{ maxWidth: "35%" }}
            className=" modal-add-user-popup modal-upload-excel-popup payOutAddHeader"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <AdditionalApptHeader
              setIsOpenSetting={setIsOpenSetting}
              switchTab={switchTab}
              header={header}
              setHeader={setHeader}
              searchFilter={searchFilter}
            />
          </Modal>

          <Modal
            isOpen={isOpenSettingForClosedAppointments}
            className=" modal-add-user-popup modal-upload-excel-popup payOutAddHeader"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <AdditionalComponentHeader
              setIsOpenSetting={setIsOpenSettingForClosedAppointments}
              header={closedAppointmentsHeaders}
              setHeader={setClosedAppointmentsHeaders}
              searchFilter={searchFilter}
            />
          </Modal>

          <Modal
            isOpen={bulkRate}
            className="modal-add-user-popup modal-upload-excel-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <BulkRateUpload setBulkRate={setBulkRate} />
          </Modal>
          <Modal
            isOpen={bulkSendToQC}
            className="modal-add-user-popup modal-upload-excel-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <SendToQcBulkUpload setBulkSendToQC={setBulkSendToQC} />
          </Modal>

          <Modal
            isOpen={isExportToExcel}
            className=" modal-add-export-advance-payout modal-upload-excel-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <PayoutExportToExcel
              setIsExporToExcel={setIsExporToExcel}
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
            />
          </Modal>

          <Modal
            isOpen={openModel?.adjustAmount}
            className="modal-add-user-popup modal-upload-excel-popup EditByFinContainer"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <PayoutAdjustment
              searchFilter={searchFilter}
              setOpenModel={setOpenModel}
              openModel={openModel}
              providerDetail={providerDetail}
              setProviderDetail={setProviderDetail}
            />
          </Modal>
        </div>
      </div>
    </div>
  );
};
